window.performPostRequest = function(e) {
	console.log('submit clicked');
	let resultElement = document.getElementById('contact_us_form_div');
	let email = document.getElementById('contact_us_email').value;
	let message = document.getElementById('contact_us_message').value;
	axios.post('/api/contact-us',{
	    email: email,
	    message: message
	}).then((response)=>{
		resultElement.innerHTML = '<div class="alert alert-success alert-dismissible"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>Thank you! Your message was successfully delivered.</div>';
	}).catch((error)=>{
		resultElement.innerHTML = '<div class="alert alert-danger alert-dismissible"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>We\'re sorry. There was an error with your submission. Please email us at gonapsacc@unc.edu.</div>';
	});
	e.preventDefault();
}

if (document.getElementById('contact_us_form_div')) {
	document.getElementById('contact_us_form').addEventListener('submit', performPostRequest);
}

function errorHTML(data) {
	let messages = '';
	for (let key in data.errors) {
		console.log(key);
		// skip loop if the property is from prototype
		if (!data.errors.hasOwnProperty(key)) continue;

		let obj = data.errors[key];
		console.log(obj);
		for (let prop in obj) {
			// skip loop if the property is from prototype
			if(!obj.hasOwnProperty(prop)) continue;

			// your code
			messages += '<p>' + obj[prop] + '</p>';
		}
	}
	return messages;
}
